import PropTypes from 'prop-types';

const overlayControllerProps = {
  buttonIconName: PropTypes.string,
  buttonProps: PropTypes.object,
  buttonContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])
};

const sharedOverlayProps = {
  overlayTitle: PropTypes.string.isRequired,
  dialogSize: PropTypes.oneOf(['normal', 'wide', 'full']),
  noPadding: PropTypes.bool,
  focusFirstChild: PropTypes.bool,
  classNames: PropTypes.arrayOf(PropTypes.string)
};

export { overlayControllerProps, sharedOverlayProps };